import { useCallback, useEffect, useRef } from 'react';
import { View, Platform } from 'react-native';
import LottieView from '../lottie/LottieView';
import { useI18nContext } from '../../i18n/i18n-react';
import { useTheme } from '../../theme';
import { resolveFont } from '../../theme/fonts';
import Text from '../typography/Text';
import PngImage from '../../utils/pngImage';

type Props = {
  /** Callback called when lottie animation finish. */
  onAnimationFinish: () => void;
  isPracticeMode?: boolean;
};

export function WellDone({ onAnimationFinish: onAnimationFinishProp, isPracticeMode }: Props) {
  const theme = useTheme();
  const translate = useI18nContext().LL;
  const animation = useRef<LottieView>(null);

  // Play the animation after 100ms
  useEffect(() => {
    const timeout = setTimeout(() => {
      animation.current?.play();
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  const onAnimationFinish = useCallback(() => {
    // Pause when finishing the animation
    // https://github.com/lottie-react-native/lottie-react-native/issues/1200#issuecomment-2069427778
    Platform.OS !== 'web' && animation.current?.pause();
    onAnimationFinishProp();
  }, [onAnimationFinishProp]);

  return (
    <View
      style={{
        flexDirection: 'row',
        columnGap: 16,
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute'
        }}
      >
        <LottieView
          ref={animation}
          loop={false}
          duration={2400}
          onAnimationFinish={onAnimationFinish}
          style={{
            width: 1246,
            backgroundColor: 'transparent',
            aspectRatio: 2046 / 1080
          }}
          source={require('../../assets/lottie/WellDone.json')}
        />
      </View>
      <PngImage
        source={
          isPracticeMode
            ? require('../../assets/images/WellDonePracticeBackground.png')
            : require('../../assets/images/WellDoneBackground.png')
        }
        style={{
          width: 1280,
          height: 600,
          zIndex: 1
        }}
      />
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Text
          style={resolveFont({
            fontFamily: 'Biotif',
            fontWeight: '900',
            fontSize: 149,
            lineHeight: 223,
            letterSpacing: -0.03,
            color: theme.colors.primary
          })}
        >
          {translate.quiz.wellDone()}
        </Text>
        <Text variant="WRN700">
          {isPracticeMode
            ? translate.quiz.youCompletedPracticeQuiz()
            : translate.quiz.youCompletedQuiz()}
        </Text>
      </View>
    </View>
  );
}
